import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import MeetingListLayer from "../components/MeetingListLayer";

const MeetingListPage = () => {
    return (
        <MasterLayout>
            <MeetingListLayer />
        </MasterLayout>
    );
};

export default MeetingListPage;
